import { InfoTooltip } from '@common/components';
import React from 'react';

export const ColumnTitleWithTooltip = ({
  children,
  tooltip,
  hasTooltip = true,
}: {
  children: string;
  tooltip?: string;
  hasTooltip?: boolean;
}) => (
  <>
    <span className="column-title-with-tooltip">
      {children}
      {hasTooltip && (
        <InfoTooltip leftOffset="lg" title={tooltip} placement="top" />
      )}
    </span>
    <style jsx>
      {`
        .column-title-with-tooltip {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-around;
        }
      `}
    </style>
  </>
);
